<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" persistent width="700px">
            <template v-slot:activator="{ on }">
                <v-btn class="caption" block color="primary" text dark v-on="on">Создать обработку события</v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Событие</v-toolbar-title>
                    <EventButtonsInFooter
                            :messageModel="eventModel"
                            @visKeyboardForm="visKeyboardForm=true"
                            @visAttachmentForm="visAttachmentForm=true"
                            @findWordBlock="eventModel.find_type = 1"
                            @moduleBlock="moduleBlock=!moduleBlock"
                            @chainBlock="eventModel.rnd = 0"
                    ></EventButtonsInFooter>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <test-message-sender
                                :modelId="eventModel.id"
                                :typeModel="'event'"
                                @testMessageSenderNotification="testMessageSenderNotification"
                        ></test-message-sender>
                        <v-btn dark text @click="saveValue" :disabled="!valid">
                            <v-icon>save</v-icon>
                            {{eventModel.id === null ? ' Создать' : ' Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list subheader class="content">
                    <v-container>
                        <v-form
                            ref="form"
                            v-model="valid"
                        >
                            <v-row class="d-flex">
                                <v-col cols="12" md12 class="py-0">
                                    <span
                                            v-show="eventModel.event === 'wall_reply_new'"
                                            :counter="35"
                                            class="ma-2 pa-2"
                                    >ID события: {{eventModel.id}}</span>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="eventModel.title"
                                            :counter="35"
                                            label="Название события"
                                            class="ma-2 pa-2"
                                            required
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-textarea
                                            auto-grow
                                            rows="1"
                                            name="input-7-1"
                                            :counter="1600"
                                            v-model="eventModel.text"
                                            label="Текст"
                                            class="ma-2 pa-2 my-0 py-0"
                                            :rules="[rules.maxLengthText]"
                                            required
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-textarea
                                            v-show="eventModel.event === 'ref'"
                                            auto-grow
                                            rows="1"
                                            name="input-7-1"
                                            :counter="1600"
                                            v-model="eventModel.error"
                                            :label="textError"
                                            class="ma-2 pa-2 my-0 py-0"
                                            :rules="[rules.maxLengthText]"
                                            required
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <media-library-block
                                            :attachments="attachments"
                                    >
                                    </media-library-block>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageButtonViewer
                                            :edit="true"
                                            :modelKeyboardId="eventModel.keyboard_id"
                                    ></MessageButtonViewer>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <event-list-select
                                            :eventModel="eventModel"
                                    ></event-list-select>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageFindWordBlock
                                            :messageModel="eventModel"
                                            :findWordBlock="findWordBlock"
                                            @saveMessage="saveValue"
                                    ></MessageFindWordBlock>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageChainBlock
                                            :messageModel="eventModel"
                                            :chainBlock="chainBlock"
                                            @saveMessage="saveValue"
                                    ></MessageChainBlock>
                                </v-col>
                                <v-col cols="9" md12 class="py-0 px-7">
                                    <MessageModuleBlock
                                            :messages="messages"
                                            :messageModel="eventModel"
                                            :moduleBlock="moduleBlock"
                                            :moduleGroups="moduleGroups"
                                            @saveMessage="saveValue"
                                            @hideBlock="moduleBlock=false"
                                            @showBlock="moduleBlock=true"
                                    ></MessageModuleBlock>
                                </v-col>
                                <v-col cols="3" v-show="moduleBlock === true">
                                    <v-btn title="Изменить группу модулей" icon small color="primary" @click="visModuleGroupListDialog = true"><v-icon>edit</v-icon></v-btn>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageSettingBlock
                                            :messageModel="eventModel"
                                            @saveMessage="saveValue"
                                    ></MessageSettingBlock>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <v-switch
                                            class="ma-0 pa-0"
                                            v-model="eventModel.user_in_group"
                                            inset
                                            label="Срабатывание события если пользователь находится в определенной группе" color="primary"
                                            :false-value="0"
                                            :true-value="1"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7" v-show="eventModel.event == 'ref'">
                                    <v-switch
                                            class="ma-0 pa-0"
                                            v-model="eventModel.replace_ref"
                                            inset
                                            label="Заменить реферала у клиента?" color="primary"
                                            :false-value="0"
                                            :true-value="1"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7" v-show="eventModel.user_in_group === 1">
                                    <mailing-groups-picker
                                            :selectedMailingGroups="selectedMailingGroups.group_ids"
                                            newLabel="Группы пользователей"
                                            :mailingGroups="mailingGroups"
                                            :edit="true"
                                            @updateGroups="updateGroups"
                                    ></mailing-groups-picker>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <KeyboardForm :visible="visKeyboardForm" :keyboards="keyboards" :keyboardId="eventModel.keyboard_id"
                      :messageModel="eventModel"
                      @close="visKeyboardForm=false"
                      @selectKeyboard="selectKeyboard"
                      @removeKeyboard="removeKeyboard"
        ></KeyboardForm>

        <attachment-form :visible="visAttachmentForm"
                         :obj-type="4"
                         :model="eventModel" @close="visAttachmentForm=false"
                         @updateAttachment="updateAttachment"
        ></attachment-form>
        <module-group-list-dialog
                :module-group-id="eventModel.module_group_id"
                :dialog="visModuleGroupListDialog"
                @close="visModuleGroupListDialog = false"
        />
        <v-snackbar
                v-model="snackbarParams.show"
                bottom
                :color="snackbarParams.color"
                right
        >
            {{snackbarParams.text}}
            <v-btn
                    dark
                    text
                    @click="snackbarParams.show = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import EventButtonsInFooter from './EventButtonsInFooter'
import EventListSelect from './EventListSelect'
import KeyboardForm from '../message/KeyboardForm'
import MessageButtonViewer from '../message/MessageButtonViewer'
import MediaLibraryBlock from '../message/MediaLibraryBlock'
import AttachmentForm from '../message/MediaLibrarySelectBox'
import MessageFindWordBlock from '../message/MessageFindWordBlock'
import MessageChainBlock from '../message/MessageChainBlock'
import MessageModuleBlock from '../message/MessageModuleBlock'
import MessageSettingBlock from '../message/MessageSettingBlock'
import MailingGroupsPicker from '../mailing/MailingGroupsPicker'
import ModuleGroupListDialog from '../module/ModuleGroupListDialog'
import { mapGetters } from 'vuex'
import TestMessageSender from '../message/TestMessageSender'

export default {
    name: 'EventForm',
    props: ['index', 'dialog', 'edit'],

    components: {
        EventButtonsInFooter,
        EventListSelect,
        KeyboardForm,
        MessageButtonViewer,
        MediaLibraryBlock,
        AttachmentForm,
        MessageFindWordBlock,
        MessageChainBlock,
        MessageModuleBlock,
        MessageSettingBlock,
        MailingGroupsPicker,
        ModuleGroupListDialog,
        TestMessageSender
    },
    data() {
        return {
            show: false,
            isActive: false,
            snackbar: false,
            eventModel: null,
            selectedMailingGroups: { excepts: [], group_ids: [] },
            visKeyboardForm: false,
            keyboardModelDef: {
                id: null,
                title: 'Кнопка',
                bot_id: null,
                one_time: 1,
                hotkey: 0,
                visible: 1,
                struct: '{}'
            },
            keyboardModel: {
                id: null
            },
            attachments: [],
            visAttachmentForm: false,
            moduleGroups: [],
            moduleBlock: false,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 35) || 'Максимальная длина названия 28 символов.',
                maxLengthText: value => (value === null || value.length <= 1600) || 'Максимальная длина сообщения 1600 символов.',
                maxLengthButton: value => (value.length <= 20) || 'Максимальная длина названия 20 символов.',
                urlValid: value => (value !== null ? !!value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9А-яЁё]+([\-\.]{1}[a-z0-9А-яЁё]+)*\.[a-zА-яЁё]{2,10}(:[0-9]{1,5})?(\/.*)?$/g) : false) || 'Ссылка имеет неверный формат. Пример верного формата https://app.chatway.ru/'
            },
            valid: false,
            visModuleGroupListDialog: false,
            snackbarParams: {
                color: 'success',
                text: 'Успешно сохранено!',
                show: false
            }
        }
    },
    methods: {
        saveValue() {
            this.$store.dispatch('events/saveEvent', this.eventModel).then(response => {
                this.eventModel = response
                this.snackbarParams.color = 'success'
                this.snackbarParams.text = 'Сохранение/создание прошло успешно!'
                this.snackbarParams.show = true
            })
        },
        loadModel(index = null) {
            if (index === null) {
                this.eventModel = Object.assign({}, this.eventModelDef)
            } else {
                this.eventModel = Object.assign({}, this.events[index])
                if (this.eventModel.module_group_id) { this.moduleBlock = true }
                let groupIds = this.eventModel.group_ids.split(',')
                for (let j = 0; j < this.mailingGroups.length; j++) {
                    for (let i = 0; i < groupIds.length; i++) {
                        if (parseInt(groupIds[i], 10) === this.mailingGroups[j].id) {
                            this.selectedMailingGroups.group_ids.push(this.mailingGroups[j])
                        }
                    }
                }
            }
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        selectKeyboard(keyboardId) {
            this.eventModel.keyboard_id = keyboardId === 0 ? null : keyboardId
            this.saveValue()
        },
        removeKeyboard(index) {
            if (this.eventModel.keyboard_id === this.keyboards[index].id) {
                this.eventModel.keyboard_id = null
                this.saveValue()
            }
            this.keyboards.splice(index, 1)
        },
        updateAttachment(data) {
            this.attachments = data.selectedItems
            let attachments = data.selectedItems
            let ids = []
            for (let i = 0; i < attachments.length; i++) {
                ids.push(attachments[i].attachmentId)
            }
            if (data.saveMessage) {
                this.eventModel.attachment = ids.join(',')
                this.saveValue() // сохранить состояние события
            }
        },
        updateGroups(data) {
            this.selectedMailingGroups[data.field] = data.selectedMailingGroups
            this.eventModel[data.field] = data.group_ids
        },
        testMessageSenderNotification({ color, text }) {
            this.snackbarParams.color = color
            this.snackbarParams.text = text
            this.snackbarParams.show = true
        }
    },
    watch: {
        dialog(value) {
            if (value === true) {
                this.loadModel(this.index)
                this.show = true
            } else {
                this.show = false
            }
        },
        show(value) {
            if (value === false) {
                this.selectedMailingGroups.group_ids.splice(0, this.selectedMailingGroups.group_ids.length)
                this.eventModel = Object.assign({}, this.eventModelDef)
                this.$refs.form.resetValidation()
                this.$emit('close')
            }
        },
        moduleBlock(value) {
            if (!value) {
                this.eventModel.module_group_id = 0
            }
        }

    },
    computed: {
        textError() {
            let text = { ref: 'Если произошла ошибка в реферальной ссылке (При ошибке модули не загружаются)' }
            return text.hasOwnProperty(this.eventModel.event) ? text[this.eventModel.event] : ''
        },
        ...mapGetters({
            events: 'events/events',
            eventModelDef: 'events/modelDefault',
            keyboards: 'keyboards/keyboards',
            mailingGroups: 'mailingGroups/mailingGroups',
            messages: 'messages/messages'
        }),
        chainBlock() {
            return this.eventModel.rnd !== -1
        },
        findWordBlock() {
            return this.eventModel.find_type !== 0
        }
    },
    created() {
        this.$store.dispatch('events/changeBotIdModelDefault', this.$route.params['pathMatch'])
        this.keyboardModelDef.bot_id = this.$route.params['pathMatch']
        this.eventModel = Object.assign({}, this.eventModelDef)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
